import apiClient from './api-client';
import { API_ENDPOINTS } from '../../constants/api.constants';
import { User, CreateAdminData } from '../../types';

export const usersService = {
  async createAdmin(data: CreateAdminData): Promise<User> {
    const response = await apiClient.post(API_ENDPOINTS.CREATE_ADMIN, data);
    return response.data.data;
  },

  async getConsumers(): Promise<User[]> {
    const response = await apiClient.get(API_ENDPOINTS.GET_CONSUMERS);
    return response.data.data;
  },

  async getAdmins(): Promise<User[]> {
    const response = await apiClient.get(API_ENDPOINTS.GET_ADMINS);
    return response.data.data;
  },

  async getProfile(): Promise<User> {
    const response = await apiClient.get(API_ENDPOINTS.PROFILE);
    return response.data.data;
  },

  async getUserById(userId: string): Promise<User> {
    const response = await apiClient.get(`${API_ENDPOINTS.USERS}/${userId}`);
    return response.data.data;
  },

  async deleteUser(userId: string): Promise<void> {
    await apiClient.delete(`${API_ENDPOINTS.USERS}/${userId}`);
  },

  async suspendUser(userId: string, suspend: boolean): Promise<User> {
    const response = await apiClient.patch(`${API_ENDPOINTS.USERS}/${userId}/suspend`, {
      suspend,
    });
    return response.data.data;
  },
};
